module.exports = __webpack_public_path__ + "img/ngerplogotxt.f0f77e2d.png";